import React,{ createContext, useContext, useState } from "react";
import useInitialState from "../hooks/useInitialState";

export const ReembolsoExpressContext = createContext();


export const ReembolsoExpressProvider = ({children}) => {
    const initialState = useInitialState()
    return <ReembolsoExpressContext.Provider value={initialState}>
        {children}
    </ReembolsoExpressContext.Provider>
}

export const useReembolsoExpressContext = () => {
    const context = useContext(ReembolsoExpressContext)
    if(context === undefined){
        throw new Error('ReembolsoExpress must be used within a ReembolsoExpressProvider')
    }
    return context
}